import "./styles/login.scss";
import logo from "../images/square_logo.webp";
import { FormEvent, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import { SetStateAction, Dispatch } from "react";
import { AuthContext } from "../context/AuthContext";
import { User } from "../interfaces/interfaces";
import { axiosInstance } from "../utils/axiosInstance";

interface Props {
  setLoggedIn: Dispatch<SetStateAction<boolean>>;
  setUser: Dispatch<SetStateAction<User>>;
  setToken: Dispatch<SetStateAction<string>>;
}

function loginErrorMessage(err: any): string {
  const data = err?.response?.data;
  if (typeof data === "string" && data.trim()) return data;
  if (data?.message && typeof data.message === "string") return data.message;
  return "Could not sign in. Please try again.";
}

export default function Login(props: Props) {
  const navigate = useNavigate();
  const { setAuthenticated } = useContext(AuthContext);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const login = async (e: FormEvent) => {
    e.preventDefault();
    if (busy) return;
    if (userName === "" || password === "") {
      setError("Please enter both your username and password.");
      return;
    }
    setBusy(true);
    setError("");
    try {
      const res = await axiosInstance.post(`/login`, { username: userName, password });
      localStorage.setItem("authToken", res.data.token);
      props.setToken(res.data.token);
      localStorage.setItem("userDetails", JSON.stringify(res.data.user));
      props.setLoggedIn(true);
      props.setUser(res.data.user);
      setAuthenticated(true);
      navigate("/home");
    } catch (err) {
      console.log(err);
      setError(loginErrorMessage(err));
      setBusy(false);
    }
  };

  return (
    <main className="sq-login">
      <section className="sq-login-brand">
        <img src={logo} alt="Speed Queen" />
        <p>Live machines, maintenance, sales and support across every store.</p>
      </section>

      <section className="sq-login-panel">
        <form className="sq-login-form" onSubmit={login} noValidate>
          <h1>Sign in</h1>
          <p className="sq-login-sub">Speed Queen admin portal</p>

          {error ? (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          ) : null}

          <label className="sq-field">
            <span>Username</span>
            <input
              id="username"
              type="text"
              className="sq-input"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              autoComplete="username"
              autoCapitalize="none"
              autoCorrect="off"
              spellCheck={false}
              autoFocus
            />
          </label>

          <label className="sq-field">
            <span>Password</span>
            <span className="sq-login-password">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                className="sq-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? "Hide password" : "Show password"}
                aria-pressed={showPassword}
              >
                {showPassword ? <IconEyeOff size={20} stroke={1.75} /> : <IconEye size={20} stroke={1.75} />}
              </button>
            </span>
          </label>

          <button type="submit" className="btn btn-primary w-100" disabled={busy}>
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </section>
    </main>
  );
}
